'use strict';

var React = require('react');

var SvgGiftCardMinor = function SvgGiftCardMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 5c0 .35.06.687.17 1h-.67a1.5 1.5 0 0 0-1.5 1.5v1.5h14v-1.5a1.5 1.5 0 0 0-1.34-1.492 3.5 3.5 0 0 0-6.022-3.523 3 3 0 0 0-4.638 2.515zm7.5 1a1.5 1.5 0 1 0-1.5-1.5v1.5h1.5zm-3.5-1v1h-1a1 1 0 1 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h5v6h-3.5a1.5 1.5 0 0 1-1.5-1.5v-4.5zm12 0h-5v6h3.5a1.5 1.5 0 0 0 1.5-1.5v-4.5z"
  }));
};

exports.SvgGiftCardMinor = SvgGiftCardMinor;
